import {
    GET_HEADING_LIST,
    GET_HEADING_LIST_SUCCESS,
    GET_HEADING_LIST_FAILURE, 
    CREATE_HEADING,
    CREATE_HEADING_SUCCESS,
    CREATE_HEADING_FAILURE,
    UPDATE_HEADING,
    UPDATE_HEADING_SUCCESS,
    UPDATE_HEADING_FAILURE,
    CHANGE_HEADING_STATUS,
    CHANGE_HEADING_STATUS_SUCCESS,
    CHANGE_HEADING_STATUS_FAILURE,
  } from "../../Actions/types";
  
  const initialState = { 
    getCategoryListData: null,
    getCategoryListLoader: false,
    getCategoryListError: false,
    updateCategoryData: null,
    updateCategoryLoader: false,
    updateCategoryError: false,
    viewHeadingData: null,
    viewHeadingLoader: false,
    viewHeadingError: false,
    createHeadingLoader: false,
    createHeadingError: false,
    createHeadingData: null,
    updateHeadingLoader: false,
    updateHeadingError: false,
    updateHeadingData: null,
    changeHeadingStatusLoader: false,
    changeHeadingStatusError: false,
    changeHeadingStatusData: null,
  };
  function headingManagementReducer(state = initialState, action) {
    switch (action.type) { 

      case CREATE_HEADING:
        return { ...state, createHeadingLoader: true };
      case CREATE_HEADING_SUCCESS:
        return {
          ...state,
          createHeadingData: action?.payload,
          createHeadingLoader: false,
        };
      case CREATE_HEADING_FAILURE:
        return {
          ...state,
          createHeadingLoader: false,
          createHeadingError: true,
        };

        case UPDATE_HEADING:
          return { ...state, updateHeadingLoader: true };
        case UPDATE_HEADING_SUCCESS:
          return {
            ...state,
            updateHeadingData: action?.payload,
            updateHeadingLoader: false,
          };
        case UPDATE_HEADING_FAILURE:
          return {
            ...state,
            updateHeadingLoader: false,
            updateHeadingError: true,
          };
    
      
          case CHANGE_HEADING_STATUS:
            return { ...state, updateHeadingLoader: true };
          case CHANGE_HEADING_STATUS_SUCCESS:
            return {
              ...state,
              changeHeadingStatusData: action?.payload,
              updateHeadingLoader: false,
            };
          case CHANGE_HEADING_STATUS_FAILURE:
            return {
              ...state,
             changeHeadingStatusData: false,
              updateHeadingError: true,
            };
      


      case GET_HEADING_LIST:
        return { ...state, changeHeadingStatusLoader: true };
      case  GET_HEADING_LIST_SUCCESS:
        return {
          ...state,
          changeHeadingStatusData: action?.payload,
          changeHeadingStatusLoader: false,
        };
      case GET_HEADING_LIST_FAILURE:
        return {
          ...state,
          changeHeadingStatusLoader: false,
          changeHeadingStatusError: true,
        }; 
      default:
        return state;
    }
  }
  
  export default headingManagementReducer;
  